import { apiClient } from "@/services/api";
import { logError } from "@/lib/error-handling";
import { OrganizationDto } from "@/types";
import {
  updateOrganizationSchema,
  UpdateOrganizationSchemaType,
} from "@/schemas/organizationSchema";

/**
 * Fetches the organization details from the API.
 * @returns Promise<OrganizationDto>
 */
export async function fetchOrganization(): Promise<OrganizationDto> {
  try {
    return await apiClient<OrganizationDto>(`/api/organizations`, {
      method: "GET",
      cache: "no-store",
    });
  } catch (error) {
    logError(error, "fetchOrganization");
    throw error;
  }
}

/**
 * Updates organization data via the API.
 * @param data - The organization data to update (validated with Zod schema)
 * @returns Promise<OrganizationDto>
 */
export async function updateOrganization(
  data: UpdateOrganizationSchemaType
): Promise<OrganizationDto> {
  try {
    // Validate data with Zod schema
    const validatedData = updateOrganizationSchema.parse(data);
    return await apiClient<OrganizationDto>(`/api/organizations`, {
      method: "PATCH",
      body: JSON.stringify(validatedData),
    });
  } catch (error) {
    logError(error, "updateOrganization");
    throw error;
  }
}
